export default __webpack_public_path__ + "static/media/checking-current-laptop-circuit-board-min.b8d2d708.jpg";